import styled from '@emotion/styled'
import React from 'react';
import {
    Space,
    Layout as AntdLayout,
} from "antd";
import { UserMenu } from './userMenu';
import { TenantDropdown } from './tenantDropdown';
import { LangDataDropdown } from './languageDataDropdown';
import { Notifications } from '../Notifications/notifications';
import { Logo } from 'components/layout/logo';
import useAuthCheck from 'components/hooks/AuthCheck';
import useMetadata from 'components/hooks/useMetadata';
import SearchDropdown from './SearchDropdown';
import { Title } from 'components/typography';
import { isSupplierOnly } from 'utility/helper';

const { Header: AntdHeader } = AntdLayout;

const HeaderWrapper = styled(AntdHeader)`
    height: 64px;
    line-height: 64px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px;
    box-shadow: 0 0 3px rgba(0,0,0,0.18);
    z-index: 1000;
`

const BrandArea = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  height: 100%;
  line-height: 1;
`

const LogoWrap = styled.div`
  width: 285px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 100%;
  line-height: 0;

  a {
    display: flex;
    align-items: center;
    width: 100%;
    line-height: 0;
  }

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`

const BrandDivider = styled.div`
  width: 1px;
  height: 28px;
  background: #d9d9d9;
  flex-shrink: 0;
`

export const Header: React.FC = () => {
  useAuthCheck();
  useMetadata();
  const supplierOnly = isSupplierOnly();
  
  return (
    <>
      <HeaderWrapper>
        <BrandArea style={{ width: supplierOnly ? 'auto' : 285 }}>
          <LogoWrap>
            <Logo collapsed></Logo>
          </LogoWrap>
          {supplierOnly && (
            <>
              <BrandDivider />
              <Title as="div" style={{ lineHeight: 1.2, whiteSpace: 'nowrap' }}>
                Partnerportal
              </Title>
            </>
          )}
        </BrandArea>
        {!supplierOnly && <SearchDropdown></SearchDropdown>}
        <Space size={"middle"}>
          {!supplierOnly && <LangDataDropdown></LangDataDropdown>}
          <TenantDropdown></TenantDropdown>
          {!supplierOnly && <Notifications></Notifications>}
          <UserMenu></UserMenu>
        </Space>
      </HeaderWrapper>
    </>
  );
};